import React from 'react';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { isEmptyBlock } from '../../types/api/Block';
import { isNullOrUndefined } from '../../lib/typeGuards';
import { PageTrashBlock } from '../../_blocks/PageTrash';

export type PageTrashWidget = WidgetShape<PageTrashBlock, WidgetType.pagetrash>;

export function PageTrashWidget({ blocks, uuid, elementType }: PageTrashWidget) {
  const { t } = useSonTranslation('Widget');

  if (!blocks || blocks.length === 0 || isNullOrUndefined(blocks[0]) || isEmptyBlock(blocks[0])) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      icon={Icons.DELETE_TRASHCAN}
      uuid={uuid}
      title={t('header.pagetrash')}
      widgetType={elementType}
      header
    >
      <PageTrashBlock {...blocks[0]} />
    </DefaultWidgetWithHeader>
  );
}
